export function searchsOffcanvas() {
    document.addEventListener('DOMContentLoaded', function () {
        const toggle = document.getElementById('search-toggle');
        const offcanvas = document.getElementById('search-offcanvas');
        const closeBtn = document.getElementById('search-close');
        const panel = offcanvas.querySelector('div');
        if( ! toggle ) {
            return;
        }
        toggle.addEventListener('click', () => {
            offcanvas.classList.remove('hidden');
            setTimeout(() => {
                panel.classList.remove('-translate-y-full');
            }, 10);
        });

        closeBtn.addEventListener('click', () => {
            panel.classList.add('-translate-y-full');
            setTimeout(() => {
                offcanvas.classList.add('hidden');
            }, 300);
        });

        offcanvas.addEventListener('click', (e) => {
            if (e.target === offcanvas) {
                closeBtn.click();
            }
        });
    });
}
export default function offcanvas() {
    document.querySelector('.menu-toggle').addEventListener('click', function (e) {
        e.preventDefault();
        const canva = document.querySelector('.tz-canvas');
        canva.classList.add('is-open');
    });
    document.querySelector('.close-offcanvas').addEventListener('click', function (e) {
        e.preventDefault();
        const canva = document.querySelector('.tz-canvas');
        canva.classList.remove('is-open');
    });
}